import { Button } from "../Button";
import { Modal } from "../Modal";
import { ModalThingsUtil as util } from "./Utils";

type IModalThings<Extras = any> = util.IModalThings<Extras>
type IModalButton = util.IModalButton

/** // NOTE: No tiene soorte para ajustar Lang context */
export function _ModalThingsBase<TExtras = any>(initTitle: string, initWidth: number, classSelected: string, modalThings?: IModalThings, initHeight?: string, forceShow = true): IModalThings<TExtras> {
    if (!modalThings) {
        const modal = new Modal()
        if (forceShow) {
            modal._Mostrar();
        }
        let progress = modal._BodySelection.append<HTMLProgressElement>("wc-progress").attr("oculto", true);

        modal._FooterSelection
            .style("justify-content", "space-between")
            .selectAll(".buttons");

        const fnGetModalBotton = (button: TSelectionHTML<"button">): IModalButton => {
            const resButton = button as IModalButton;
            resButton.fn_Enable = () => (Button._EnableButton(button, true), resButton);
            resButton.fn_Disable = () => (Button._EnableButton(button, false), resButton);
            resButton._Enable = (enable: boolean) => (Button._EnableButton(button, enable), resButton);
            return resButton;
        }

        modalThings = {
            Progress: progress as any as TSelectionHTML<"wc-progress">,
            Modal: modal,
            CurrentBody: null,
            BtnLeft: fnGetModalBotton(modal._BtnLeftSelection),
            BtnRight: fnGetModalBotton(modal._BtnRightSelection),
        };
    }

    modalThings.Modal._BodySelection
        .style("height", null)
        .selectAll(":scope > div")
        .classed("hide", true);

    modalThings.CurrentBody = modalThings.Modal._BodySelection.select("." + classSelected);

    if (!modalThings.CurrentBody.node()) {
        modalThings.CurrentBody = modalThings.Modal._BodySelection.append("div")
            .classed(classSelected, true);
    }

    modalThings.Modal._ModalSelection
        .style("width", initWidth + "px")
        .style("height", (initHeight || null));

    modalThings.CurrentBody
        .classed("hide", false)
        .style("height", "100%");
    modalThings.BtnLeft.classed("hide_transparent", true).on("click", null);
    modalThings.BtnLeft.on("click", null);
    modalThings.Modal._SetTitle(initTitle);
    return modalThings;
}